import { ampersandList } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";

import AnomalyDetail from "../anomaly-detail";

import { IProps } from "./anomaly-tags.types";
import "./anomaly-tags.scss";

/**
 * List an anomaly's tags.
 * @param props.tags Anomaly's tags.
 * @returns          Anomaly's tags and icon.
 */
const AnomalyTags: FunctionComponent<IProps> = ({ label, tags, ...anomalyDetailProps }) => {
    return (
        <AnomalyDetail
            {...anomalyDetailProps}
            label={label}
            styleName="positive"
            value={ampersandList(tags.map(({ tag }) => tag))}
        />
    );
};

export default memo(AnomalyTags);
